import { Injectable } from '@angular/core';

import { Docorga } from '@docorga-v1/docorga-common';

import { DataService } from './data.service';

@Injectable()
export class DocumentService extends Docorga.services.DocumentService {
  constructor(DataService: DataService) {
    super(DataService);
  }
}
